import { useEffect, useState } from "react";
import { Download, Share, ShieldCheck, X } from "lucide-react";

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const ClienteInstallButton = ({ p = "cliente" }) => {
  const [prompt, setPrompt] = useState(null);
  const [ios] = useState(() => !isStandalone() && isIos());
  const [installed, setInstalled] = useState(isStandalone);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  if (installed || (!prompt && !ios && !open)) return null;

  const click = async () => {
    setOpen(true);
    if (prompt) { prompt.prompt(); await prompt.userChoice.catch(() => {}); setPrompt(null); }
  };

  return (
    <div className="mt-6" data-testid={`${p}-install-wrap`}>
      {(prompt || ios) && (
        <button type="button" onClick={click} data-testid={`${p}-install-app-btn`}
          className="w-full h-11 inline-flex items-center justify-center gap-2 rounded-lg border border-amber-500/60 text-amber-400 hover:bg-amber-500/10 text-sm font-semibold transition-colors">
          <Download className="h-4 w-4" />Installa App
        </button>
      )}
      {open && (
        <div className="mt-3 rounded-lg border border-slate-700 bg-slate-900/80 p-3 text-sm pgp-fade-up relative" data-testid={`${p}-install-info`}>
          <button type="button" onClick={() => setOpen(false)} title="Chiudi" data-testid={`${p}-install-info-close`}
            className="absolute top-2 right-2 p-1 rounded-md text-slate-500 hover:bg-slate-800 transition-colors"><X className="h-4 w-4" /></button>
          <div className="flex gap-2 pr-6 text-slate-200" data-testid={`${p}-secure-msg`}>
            <ShieldCheck className="h-5 w-5 text-amber-500 shrink-0" />
            <span>Questo è un collegamento sicuro del tuo studio. Accedi con le credenziali ricevute.</span>
          </div>
          {ios && (
            <div className="mt-2 flex flex-wrap items-center gap-1 text-slate-400 text-xs" data-testid={`${p}-ios-install-hint`}>
              Per installare: tocca <Share className="h-3.5 w-3.5" /> Condividi poi Aggiungi a schermata Home
            </div>
          )}
        </div>
      )}
    </div>
  );
};
